import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=6a1c9b3a&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a1c9b3a')) {
      api.createRecord('6a1c9b3a', component.options)
    } else {
      api.reload('6a1c9b3a', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=6a1c9b3a&", function () {
      api.rerender('6a1c9b3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4hF4RzGF0ycu7/JS/comp/ImgFallback.vue"
export default component.exports